import {
  Box,
  Grid,
  Typography,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { updateThemeConfig } from "../../actions";
import { formatName } from "./ThemeConfig";


function ColorComponent({ ...props }) {
  const dispatch = useDispatch();
  return (
    <Box sx={{padding:'15px 0 !important'}}>
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={6}>
          <Typography>{formatName(props.field.name)}</Typography>
        </Grid>
        <Grid item xs={6} container alignItems="center" justifyContent="flex-end">
           <input
            type="color"
            className="form-control col-6"
            id={props.field.name}
            name={props.field.name}
            defaultValue={props.field.value}
            onBlur={(e) => {
              dispatch(updateThemeConfig(props.field.name, e.target.value));
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default ColorComponent;
